import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import * as benchlingUtil from 'BenchlingUtil';
import {ProtocolSection} from 'notebook/ELNConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

interface Props {
  sections: Array<ProtocolSection>;
  stepByStepURL: string;
}

export default class Navigation extends React.Component<Props> {
  navRef = React.createRef<HTMLDivElement>();

  componentDidMount(): void {
    // Should be okay to call scrollspy multiple times if multiple mounts.
    $('body').scrollspy({
      target: '.protocol-nav',
      offset: 30,
    });
    const $node = $(ReactDOM.findDOMNode(this.navRef.current)!);
    let offsetTop: number | null = null;
    // eslint-disable-next-line no-return-assign
    const resize = (): number => (offsetTop = $node.parent().offset()!.top);
    resize();
    $node.affix({
      offset: {
        top() {
          return offsetTop;
        },
      },
    });
    $(window).on('resize.protocolnav', resize);
    $(ReactDOM.findDOMNode(this)!).find('a').tooltip({
      placement: 'right',
      container: 'body',
    });
  }

  componentWillUnmount(): void {
    $(window).off('.protocolnav');
  }

  render(): JSX.Element {
    return (
      <div className="protocol-nav-wrapper">
        <div className="protocol-nav" ref={this.navRef}>
          <ul className="nav">
            {Array.from(this.props.sections).map((section) => (
              <li key={section.key}>
                <a href={`#proto-${section.key}`} title={section.tooltip}>
                  {section.icon}
                </a>
              </li>
            ))}
            <li key="show-step-by-step">
              {
                // onTouchStart handler to allow :active state to work on mobile safari.
                <a
                  title="Step-By-Step"
                  className="step-by-step-btn"
                  href={this.props.stepByStepURL}
                  onTouchStart={function () {
                    return null;
                  }}
                  onClick={function (e: ElementMouseEvent): void {
                    benchlingUtil.navigate(e);
                  }}
                >
                  <BenchlingIcon icon="play" />
                </a>
              }
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
